import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'people-tab',
  templateUrl: './people-tab.component.html',
  styleUrls: ['./people-tab.component.scss']
})
export class PeopleTabComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
